var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 20",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.475 11.224V19.2h4.35v-7.976h3.244l.675-3.668H6.825V6.26c0-1.939.761-2.681 2.726-2.681.611 0 1.103.014 1.388.045V.296C10.402.15 9.09 0 8.332 0 4.325 0 2.475 1.894 2.475 5.978v1.578H0v3.668z"
})));
export default SvgFacebook;